import Linkify from "linkify-react";
import type { Opts } from "linkifyjs";

const linkifyOptions: Opts = {
  target: "_blank",
  rel: "noopener noreferrer",
  validate: {
    url: (href: string) => /^https?:\/\//i.test(href),
    email: () => false,
  },
};

type MessageTextBodyProps = {
  text: string;
  className?: string;
};

export function MessageTextBody({ text, className }: MessageTextBodyProps) {
  return (
    <div className={className}>
      <Linkify options={linkifyOptions}>{text}</Linkify>
    </div>
  );
}
